<div class="tasks-by-practice-area">
  <!-- Filters Row (Horizontal) -->
  @if (isFilterVisible) {
    <div class="filters-row">
      <div class="horizontal-filters-container">
        <!-- Practice Area Filter -->
        <div class="filter-item">
          <label>Practice Areas</label>
          <ng-select
            class="custom-select practice-area-select"
            [items]="practiceAreas"
            [multiple]="true"
            [closeOnSelect]="false"
            [hideSelected]="false"
            bindLabel="description"
            bindValue="description"
            placeholder="Select Practice Areas"
            [(ngModel)]="selectedPracticeAreas"
            [loading]="loading"
            [virtualScroll]="true"
            [clearable]="true"
            appendTo="body"
            (change)="onPracticeAreaSelectionChange($event)">
          </ng-select>
        </div>
        <!-- Apply and Clear Filters -->
        <div class="filter-actions">
          <button class="btn btn-primary apply-btn" (click)="applyFilters()">Apply</button>
          <button class="btn btn-outline-secondary clear-btn" (click)="clearFilters()">
            <i class="bx bx-x-circle"></i> Clear
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Chart Row -->
  <div class="row">
    <!-- Chart Column (Full Width) -->
    <div class="col-12 chart-column">
      <div class="chart-container" #chartContainer>
        <!-- Error state -->
        @if (error) {
          <div class="alert alert-danger">
            <span>⚠️ {{ error }}</span>
            <button class="btn btn-link" (click)="retry()">Try Again</button>
          </div>
        }

        <!-- Loading state -->
        @if (loading) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
          </div>
        }

        <!-- Chart -->
        @if (!loading && !error && chartConfig.data.length > 0) {
          <div class="chart-content">
            <ngx-charts-bar-horizontal
              [view]="chartConfig.view"
              [scheme]="chartConfig.scheme"
              [results]="chartConfig.filteredData"
              [gradient]="false"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="false"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [legendPosition]="chartConfig.legendPosition"
              [animations]="true"
              [roundEdges]="false"
              [roundDomains]="chartConfig.roundDomains"
              [showGridLines]="chartConfig.showGridLines"
              [xAxisLabel]="chartConfig.xAxisLabel"
              [yAxisLabel]="'Practice Area'"
              [showDataLabel]="true"
              [barPadding]="chartConfig.barPadding"
              [trimXAxisTicks]="chartConfig.trimXAxisTicks"
              [trimYAxisTicks]="chartConfig.trimYAxisTicks"
              [maxXAxisTickLength]="chartConfig.maxXAxisTickLength"
              [maxYAxisTickLength]="chartConfig.maxYAxisTickLength"
              [animations]="true"
              (select)="onSelect($event)">
            </ngx-charts-bar-horizontal>
          </div>
        }

        <!-- No data state -->
        @if (!loading && !error && chartConfig.data.length === 0) {
          <div class="no-data-message">
            <i class="bi bi-inbox fs-2 text-muted"></i>
            <p class="text-muted mt-2">No tasks found</p>
          </div>
        }
      </div>
    </div>
  </div>
</div>
